import { Box, Typography } from "@mui/material";
import { JustifyAllStrandLossesButton } from "../../buttons/JustifyAllStrandLossesButton";

interface LossDetailsHeaderProps {
  canJustifyAll: boolean;
  isJustifying: boolean;
  onJustifyAll: () => void;
}

export const LossDetailsHeader = ({
  canJustifyAll,
  isJustifying,
  onJustifyAll,
}: LossDetailsHeaderProps) => (
  <Box
    sx={{
      alignItems: "center",
      display: "flex",
      gap: 0.5,
      justifyContent: "center",
      minWidth: 0,
      px: 0.5,
      width: "100%",
    }}
  >
    <Typography component="span" variant="caption" fontWeight={600} noWrap>
      Loss Details
    </Typography>
    {canJustifyAll ? (
      <JustifyAllStrandLossesButton
        isJustifying={isJustifying}
        onJustifyAll={onJustifyAll}
      />
    ) : null}
  </Box>
);
